module.exports = __webpack_public_path__ + "amcharts/images/xIcon.gif";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/xIcon.gif
// module id = 282
// module chunks = 0